// extracted by mini-css-extract-plugin
export default {"phone":"PhoneComponent_phone__os9lU","img":"PhoneComponent_img__blFyH"};